import React from 'react';
import { View as RNView, StyleProp, StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { MBUserImage } from '@shared/components/image';
import { MBTextBody1 } from '@shared/components/typography';
import { Colors, grid } from '@shared/styles';
import { User } from '@shared/types/user';
import { Pill } from './Pill';

interface Props {
  user: User;
  maxWidth?: number | 'none';
  noBorder?: boolean;
  showLastName?: boolean;
  pillStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

export function PersonPill({
  user,
  maxWidth = 180,
  noBorder = false,
  showLastName = true,
  pillStyle,
  textStyle,
}: Readonly<Props>) {
  const styles = StyleSheet.create({
    row: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: '100%',
      flexWrap: 'nowrap',
      alignSelf: 'flex-start',
      maxWidth,
    },
    image: {
      width: noBorder ? grid(3) : grid(2),
      height: noBorder ? grid(3) : grid(2),
      display: 'flex',
      borderRadius: noBorder ? grid(3) : grid(2),
      overflow: 'hidden',
      marginRight: grid(1),
      marginLeft: noBorder ? 0 : -grid(0.5),
      flexShrink: 0,
    },
    name: {
      flexGrow: 1,
      flexShrink: 0,
      textAlign: 'left',
    },
  });

  const imageWidth = noBorder ? grid(3) : grid(2);

  return (
    <Pill
      backgroundColor="white"
      round
      key={user.id}
      maxWidth={undefined}
      noBorder={noBorder}
      borderColor={Colors.v2.gray50_25}
      style={pillStyle}
    >
      <RNView style={styles.row}>
        <RNView style={styles.image}>
          <MBUserImage
            user={user}
            size={noBorder ? 'small' : 'tiny'}
            style={{ width: imageWidth, height: imageWidth }}
          />
        </RNView>
        <MBTextBody1 style={[styles.name, textStyle]} numberOfLines={1}>
          {showLastName ? user.fullName : user.firstName}
        </MBTextBody1>
      </RNView>
    </Pill>
  );
}
